<ng-template #horizontalLayout>
  <div class="ancillary-content">
    @if (hasImage()) {
      <div class="image-container" (click)="openPhotoGallery($event)">
        <img [src]="getImageUrl()" alt="Room" class="ancillary-image" />
      </div>
    } 
    <!-- @else {
      <div class="image-container no-image" (click)="openPhotoGallery($event)">
        <div class="offer-image-placeholder">No image</div>
      </div>
    } -->

    <div class="text-group text-ancillary">
      <!-- <span class="room-name">
        {{ offer?.upsell_room_category_name | titlecase }}
      </span> -->
       <div style="display: flex; align-items: center;">
          <span class="offer-room-text">{{ offer?.upsell_room_category_name | titlecase }}</span>
          <button
            type="button"
            class="info-icon-button"
            [attr.aria-expanded]="infoTooltipOpen"
            aria-haspopup="tooltip"
            (click)="toggleInfoTooltip($event)"
            (blur)="closeInfoTooltip()">
            <span class="material-icons info-icon">info</span>
          </button>
          @if (infoTooltipOpen) {
            <div class="info-tooltip-row" role="tooltip">
              <p>{{ offer?.amenities?.summary }}</p>
            </div>
          }
        </div>

      <p class="price-text">
        <span class="price-amount">{{ offer?.ofr_price | currency:'USD' : 'symbol' : '1.2-2' }} Extra</span>
      </p>
    </div>

    <div class="button-container btn-container-horizontal">
      @if (sharedService.requestOnlyMode) {
        <button
          class="button-offer-card ancillary-button card-action-desktop"
          [class.button-disabled]="checkIfDisabled()"
          (click)="requestUpgrade()">
          Request Upgrade
        </button>
      }

      @if (!checkIfOfferInCart() && !sharedService.requestOnlyMode) {
        <button
          class="button-offer-card ancillary-button card-action-desktop"
          type="button"
          [class.button-disabled]="checkIfDisabled()"
          (click)="addToCartAndContinue($event);">
          <span class="material-icons cart-icon">add_shopping_cart</span>
          <span class="cart-label">Add to Cart</span>
        </button>
      }

      @if (checkIfOfferInCart() && !sharedService.requestOnlyMode) {
        <button
          class="button-offer-card ancillary-button card-action-desktop"
          [class.button-disabled]="checkIfDisabled()"
          (click)="removeOfferFromCart();">
          <span class="material-icons cart-icon">remove_shopping_cart</span>
          <span class="cart-label">Remove</span>
        </button>
      }
    </div>
  </div>
</ng-template>

<ng-template #verticalLayout>
  <div class="vertical-container">
    @if (hasImage()) {
      <div class="image-container-vertical" (click)="openPhotoGallery($event)">
        <img [src]="getImageUrl()" alt="Room" class="ancillary-image-vertical" />
      </div>
    } 
    <!-- @else {
      <div class="image-container-vertical no-image" (click)="openPhotoGallery($event)">
        <div class="offer-image-placeholder">No image</div>
      </div>
    } -->

    <div class="offer-card-row card-row-handset">
      <div class="offer-room-label text-ancillary">
        <div style="display: flex; align-items: center;">
          <!-- clipRoomText(offer?.upsell_room_category_name!, 21) -->
           <!-- offer?.upsell_room_category_name -->
          <span class="offer-room-text" >{{ clipRoomText(offer?.upsell_room_category_name!, 21) | titlecase }}</span>
          <button
            type="button"
            class="info-icon-button"
            [attr.aria-expanded]="infoTooltipOpen"
            aria-haspopup="tooltip"
            (click)="toggleInfoTooltip($event)"
            (blur)="closeInfoTooltip()">
            <span class="material-icons info-icon">info</span>
          </button>

        </div>

        <span class="offer-price-label"> <span class="price-amount">{{ offer?.ofr_price | currency:'USD':'symbol':'1.2-2' }} Extra</span></span>
      </div>
      <div class="btn-container-vertical">
        @if (sharedService.requestOnlyMode) {
          <button
            class="button-offer-card ancillary-button ancillary-button-handset card-action-handset"
            [class.button-disabled]="checkIfDisabled()"
            (click)="requestUpgrade()">
            Request Upgrade
          </button>
        }

        @if (!sharedService.requestOnlyMode && !checkIfOfferInCart()) {
          <button
            class="button-offer-card ancillary-button ancillary-button-handset card-action-handset"
            type="button"
            [class.button-disabled]="checkIfDisabled()"
            (click)="addToCartAndContinue($event);">
            <span class="material-icons cart-icon">add_shopping_cart</span>
            <span class="cart-label">Add to Cart</span>
          </button>
        }

        @if (!sharedService.requestOnlyMode && checkIfOfferInCart()) {
          <button
            class="button-offer-card ancillary-button ancillary-button-handset card-action-handset"
            [class.button-disabled]="checkIfDisabled()"
            (click)="removeOfferFromCart()">
            <span class="material-icons cart-icon">remove_shopping_cart</span>
            <span class="cart-label">Remove</span>
          </button>
        }
      </div>
    </div>
    @if (infoTooltipOpen) {
      <div class="info-tooltip-grid" role="tooltip">
        <p>{{ offer?.upsell_room_category_name! }}</p>
        <br>
        <p>{{ offer?.amenities?.summary }}</p>
      </div>
    }
  </div>
</ng-template>

<div class="lx-card">
  <div class="ancillary-container" [class.force-vertical]="shouldUseVerticalLayout()">
    @if (shouldUseVerticalLayout()) {
      <ng-container [ngTemplateOutlet]="verticalLayout"></ng-container>
    } @else {
      <ng-container [ngTemplateOutlet]="horizontalLayout"></ng-container>
    }
  </div>
</div>
